const TeamMembersData = [
    {
        Name: "Alisa Hester",
        Position: "Founder & CEO",
        Roles: "Former co-founder of Opendoor. Early staff at Spotify and Clearbit.",
        Image: "https://bafybeiaihi3zlsfoa4x6rqhtunypiq2ccft7pmwhop6agxxvcnqhhvsdmm.ipfs.infura-ipfs.io/"
    },
    {
        Name: "Rich Wilson",
        Position: "Engineering Manager",
        Roles: "Lead engineering teams at Figma, Pitch, and Protocol Labs.",
        Image: "https://bafybeihyhc5sn4xhx42zncllyqa6hzmwptjl4xhpeejkruoxhehkbkcjei.ipfs.infura-ipfs.io/"
    },
    {
        Name: "Annie Stanley",
        Position: "Product Manager",
        Roles: "Former PM for Airtable, Medium, Ghost, and Lumi.",
        Image: "https://bafybeibogwxdvohmomdaajlfs6h7dps4s3vtciemyvww2mcubvu7d2vnlu.ipfs.infura-ipfs.io/"
    },
    {
        Name: "Alisa Hester",
        Position: "Founder & CEO",
        Roles: "Former co-founder of Opendoor. Early staff at Spotify and Clearbit.",
        Image: "https://bafybeifu4nyzw6uxaae4rk2vxoq7psjxefjpwmeiitmsknmh7svwjwlevu.ipfs.infura-ipfs.io/"
    },
    {
        Name: "Rich Wilson",
        Position: "Engineering Manager",
        Roles: "Lead engineering teams at Figma, Pitch, and Protocol Labs.",
        Image: "https://bafybeid3egcozej4h33theryvia27hrzhhyiurozwjekdaztokefqq44r4.ipfs.infura-ipfs.io/"
    },
    {
        Name: "Annie Stanley",
        Position: "Product Manager",
        Roles: "Former PM for Airtable, Medium, Ghost, and Lumi.",
        Image: "https://bafybeihv7ijy6jniaszyqz26vyev2qbr3wldczj5ih5tio2hohh3n5kxca.ipfs.infura-ipfs.io/"
    },
]

export default TeamMembersData